export default "__VITE_ASSET__Mgt$w6uZ__"